export type EnquiryData = {
    _id?: string;
    dateOfEnquiry?: string;
    institutionName?: string;
    enquiryPurpose?: string;
    enquiryAmount?: string;
    tenure?: string;
    directorId?: string;
    assesseeId?: string;
};

export type BureauEnquiryTableProps = {
    data: EnquiryData[];
    loading: boolean;
    vendorType: VendorType;
};

export type VendorType = 'EQUIFAX' | 'EXPERIAN' | 'TRANSUNION';

// Bureau-type enum-like constant. Use BureauType.X instead of inline string literals
// for type-safety + grep-ability. Includes ALL (the "no specific bureau" filter value)
// alongside the three real bureaus.
export const BureauType = {
    EQUIFAX: 'EQUIFAX',
    EXPERIAN: 'EXPERIAN',
    TRANSUNION: 'TRANSUNION',
    ALL: 'All',
} as const;
export type BureauTypeValue = (typeof BureauType)[keyof typeof BureauType];

export const NEW_TO_CREDIT_THRESHOLD = 100;

// Maximum possible bureau score (denominator for the score progress bars).
export const MAX_BUREAU_SCORE = 900;

export const REFRESH_BUREAU_CTA = 'Refresh Bureau';

export const UNIFIED_REPORT_ALL_TAB_HINT = 'Select an individual bureau from the toggle above to view combined reports of directors.';

/** How far back the Director Bureau enquiry banner counts enquiries. */
export const ENQUIRY_LOOKBACK_YEARS = 1;

export const ENQUIRY_BANNER_LINK_LABEL = 'View Details';

/**
 * The banner is the only entry point to the enquiry drawer, and the drawer shows full history with
 * no lookback — so it has to appear whenever there are any enquiries at all, not just recent ones.
 * The lookback only decides which sentence it gets.
 */
export function enquiryBannerText(recentCount: number, totalCount: number): string {
    const count = recentCount > 0 ? recentCount : totalCount;
    const subject = `There ${count === 1 ? 'is' : 'are'} ${count} Bureau ${count === 1 ? 'Enquiry' : 'Enquiries'}`;

    return recentCount > 0 ? `${subject} in the last ${ENQUIRY_LOOKBACK_YEARS} year.` : `${subject} on record.`;
}
